import { Directive, ViewContainerRef } from "@angular/core";
import { ViewRef } from "@angular/core";

@Directive({
  selector: "[form-root], form-root"
})
export class FormRootDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}

  public getViewRef(index: number): ViewRef {
    return this.viewContainerRef.get(index);
  }

  public getViewRefs(): ViewRef[] {
    const viewRefs = [];
    for (let i = 0; i < this.getSize(); i++) {
      viewRefs.push(this.viewContainerRef.get(i));
    }
    return viewRefs;
  }

  public containsViewRef(viewRef: ViewRef): boolean {
    return this.viewContainerRef.indexOf(viewRef) !== -1;
  }

  public getSize(): number {
    return this.viewContainerRef.length;
  }

  public clearView(): void {
    this.viewContainerRef.clear();
  }
}
